import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "yogi-man",
  "use": "yogi-man-usage",
  "viewBox": "0 0 216 70",
  "content": "<symbol viewBox=\"0 0 216 70\" xmlns=\"http://www.w3.org/2000/svg\" id=\"yogi-man\"><path d=\"M0.0732422 1.0003H48.9736C55.1925 1.0003 59.9031 6.61629 58.821 12.7403L53.1226 44.9896C50.9584 57.2377 60.3798 68.4697 72.8176 68.4696L105.969 68.4695L139.584 68.4697H215.107\" stroke-width=\"1.5\" /><circle cx=\"8.88883\" cy=\"8.88883\" r=\"8.13883\" transform=\"matrix(1 0 0 -1 133.54 68.6699)\" stroke-width=\"1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol